import { createPageConfig } from '@tarojs/runtime'
import component from "../../../node_modules/babel-loader/lib/index.js!./index.tsx"
var config = {"navigationBarTitleText":"虚拟列表"};


var inst = Page(createPageConfig(component, 'pages/virtual-list-demo/index', {root:{cn:[]}}, config || {}))

